import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedServiceService } from '../services/shared-service.service';
import { environment } from '../../environments/environment';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button'; // Optional if buttons used inside
import { NgIf, NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  imports: [
    MatSidenavModule,  // ✅ Required for <mat-sidenav-container> and <mat-sidenav-content>
    NgIf,
    NgClass,
    RouterLink
  ],
})
export class NavbarComponent implements OnInit {
  oldDhruva = environment.oldDhruvaUrl;
  userRole: string = '';
  activeSection: string = '';
  recipesExpanded: boolean = false;

  // Every route that belongs to a given side-nav tab, so the icon stays
  // active while the user is anywhere inside that tab's section (e.g. a
  // member's detail page still belongs to the Members tab).
  private sectionRoutes: Record<string, string[]> = {
    dashboard: ['/dashboard'],
    members: ['/members', '/member-details', '/member-dashboard', '/members-assignment', '/edit-food-log'],
    teams: ['/teams', '/team-create', '/team-edit'],
    calendar: ['/event-calender'],
    'quest-mindfulness': ['/quest-mindfulness-creation'],
    'meal-plans': [
      '/meal-plans', '/create-plan', '/meal-plan-result', '/all-meal-plans',
      '/view-meal-plan', '/search-result', '/meal-details',
      '/v2/create-plan', '/v2/all-meals', '/view-edit-plan', '/template-view'
    ],
    fitness: ['/fitness-plan', '/create-fitness-plan', '/upload-plan'],
    recipes: ['/recipes', '/add-recipe', '/update-recipe'],
    'data-analysis': ['/data-analysis'],
  };

  constructor(
    private sharedService: SharedServiceService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.userRole = this.sharedService.getloggedUserRole();
  }

  isRouteActive(path: string): boolean {
    return this.router.url.startsWith(path);
  }

  isSectionActive(section: string): boolean {
    const prefixes = this.sectionRoutes[section] || [];
    return prefixes.some(p => this.router.url.startsWith(p));
  }

  setActive(section: string): void {
    this.activeSection = section;
  }

  toggleRecipesSubmenu(): void {
    this.recipesExpanded = !this.recipesExpanded;
  }
}
